export default __webpack_public_path__ + "static/media/GHA.950cc02d.svg";